import { LPKid, LPView, View } from './interfaces';
import has from '@dojo/framework/core/has';

export const viewFromLpl = (lpl: LPView): View => {
	const { widget } = lpl;
	const params: Partial<View> = { ...lpl };
	delete params['widget'];
	return { widget, params };
};

export const assessment = (quizid: string, title: string): LPView => {
	return {
		widget: 'LPView',
		view: 'assessment-view',
		kids: [
			{
				widget: 'Group',
				name: 'assessment-body',
				classes: ['assessment-body'],
				kids: [
					{
						widget: 'Widget',
						name: 'assessment-quiz',
						realwidget: 'quiz',
						jsondata: `{"topicid": "${quizid}", "title": "${title}"}`
					}
				]
			}
		]
	};
};

export const practice = (quizid: string, title: string): LPView => {
	return {
		widget: 'LPView',
		view: 'practice-view',
		kids: [
			{
				widget: 'Group',
				name: 'practice-body',
				classes: ['practice-body'],
				kids: [
					{
						widget: 'Widget',
						name: 'practice-quiz',
						realwidget: 'quiz',
						jsondata: `{"topicid": "${quizid}", "title": "${title}"}`
					}
				]
			}
		]
	};
};

export const bonus = (quizid: string, title: string): LPView => {
	return {
		widget: 'LPView',
		view: 'bonusquiz-view',
		kids: [
			{
				widget: 'Group',
				name: 'bonusquiz-body',
				classes: ['bonusquiz-body'],
				kids: [
					{
						widget: 'Widget',
						name: 'bonus-quiz',
						realwidget: 'quiz',
						jsondata: `{"topicid": "${quizid}", "title": "${title}"}`
					}
				]
			}
		]
	};
};

export const posttest = (quizid: string, title: string): LPView => {
	const kids: LPKid[] = [
		{
			widget: 'Widget',
			name: 'posttest-quiz',
			realwidget: 'quiz',
			jsondata: `{"topicid": "${quizid}", "title": "${title}"}`
		}
	];

	if (has('use-micro-view')) {
		kids.unshift({
			widget: 'Widget',
			name: 'posttest-breadcrumbs',
			realwidget: 'MicroBreadcrumbs',
			jsondata: '{}'
		});
	}

	return {
		widget: 'LPView',
		view: 'posttest-view',
		kids: [
			{
				widget: 'Group',
				name: 'posttest-body',
				classes: ['posttest-body'],
				kids
			}
		]
	};
};

export const quiz = (quizid: string, title: string): LPView => {
	return {
		widget: 'LPView',
		view: 'quiz-view',
		kids: [
			{
				widget: 'Group',
				name: 'quiz-body',
				classes: ['quiz-body'],
				kids: [
					{
						widget: 'Widget',
						name: 'quiz-breadcrumbs',
						realwidget: 'MicroBreadcrumbs'
					},
					{
						widget: 'Widget',
						name: 'general-quiz',
						realwidget: 'quiz',
						jsondata: `{"topicid": "${quizid}", "title": "${title}"}`
					}
				]
			}
		]
	};
};
